import { Component, Output, EventEmitter, Input, TemplateRef, OnDestroy } from '@angular/core';
import { Resource, ResourceService, TrackingService, EVENTS, CurrencyChangerService } from '@clooper/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { BookingRestrictionModalComponent } from '../booking-restriction-modal/booking-restriction-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { faHouseUser } from '@fortawesome/pro-light-svg-icons/faHouseUser';
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import { faChild } from '@fortawesome/pro-light-svg-icons/faChild';
import { faBaby } from '@fortawesome/pro-light-svg-icons/faBaby';
import { faCat } from '@fortawesome/pro-light-svg-icons/faCat';
import { faSlidersH } from '@fortawesome/pro-light-svg-icons/faSlidersH';
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faCalendarPlus } from '@fortawesome/pro-light-svg-icons/faCalendarPlus';
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnDestroy {
  @Input() resource: string;
  @Input() service: ResourceService<Resource>;
  @Output() resources: EventEmitter<any> = new EventEmitter();
  @Output() onsearch: EventEmitter<any> = new EventEmitter();
  @Output() pushForEnquiry: EventEmitter<any> = new EventEmitter();
  minDate: Date;

  bsModalRef?: BsModalRef;

  occupant_types = [
    { name: 'rooms', icon: faHouseUser, subText: '', default: 1 },
    { name: 'adults', icon: faUsers, subText: '', default: 1 },
    { name: 'children', icon: faChild, subText: '(2-17 years)', default: 0 },
    { name: 'infants', icon: faBaby, subText: '(Under 2 years)', default: 0 },
    { name: 'pets', icon: faCat, subText: '', default: 0 },
  ]

  occupant_form_array: { [x: string]: FormControl; }[] = []
  form: FormGroup
  dateRange: Date[];

  /** Boolean variable for enabling and disabling the search bar */
  isSearchBtnEnabled: boolean = false;

  filter: any = {
    // search: true
  };

  icons = {
    search: faSearch,
    sliderH: faSlidersH,
    caretDown: faAngleDown,
    calendar: faCalendarPlus,
    caretUp: faAngleUp,
    users: faUsers,
  }
  latlng: any
  searchRadius = 20;
  miles = [5, 10, 20, 30, 40, 50, 60, 70, 80];
  currentUrl: string = "/listings";
  routerSubs: any;
  searchValue: string;
  checkIn: Date;
  checkOut: Date;
  queryParamsSubs: Subscription;
  selectedCurrency: string = 'GBP';

  constructor(
    private route: ActivatedRoute,
    private tracker: TrackingService,
    private fb: FormBuilder,
    private router: Router,
    private modalService: BsModalService,
    private currency: CurrencyChangerService
  ) {
    const data = this.currency.getSelectedCurrency()
    if (data !== null) {

      this.selectedCurrency = data?.currency;
    } else {
      this.selectedCurrency = 'GBP'
    }

    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());

    this.occupant_form_array = this.occupant_types.map(occupant_type => {
      return {
        [occupant_type.name + ""]: new FormControl(occupant_type.default, []),
      }
    });
    let occupant_form = Object.assign({}, ...this.occupant_form_array);
    this.form = this.fb.group({
      rooms: new FormControl('', []),
      check_in: new FormControl('', []),
      check_out: new FormControl('', []),
      occupants: new FormControl('', []),
      ...occupant_form
    })

    this.routerSubs = this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationEnd) {
          this.currentUrl = event.url

        }
      })

    this.queryParamsSubs = this.route.queryParams.subscribe((params) => {
      this.latlng = params.latlng
      this.searchValue = params.s || ''

      if (+params.checkIn && +params.checkOut) {
        this.checkIn = new Date(+params.checkIn)
        this.checkOut = new Date(+params.checkOut)
        this.dateRange = [this.checkIn, this.checkOut]
      }

      +params.rooms ? this.form.controls['rooms'].setValue(+params.rooms) : null;
      +params.adults ? this.form.controls['adults'].setValue(+params.adults) : null;
      +params.children ? this.form.controls['children'].setValue(+params.children) : null;
      +params.pets ? this.form.controls['pets'].setValue(+params.pets) : null;
      +params.infants ? this.form.controls['infants'].setValue(+params.infants) : null;

      if (params.rooms || params.adults || params.infants || params.pets || params.children)
        this.constructString()
    })
  }

  ngOnInit(): void {
    this.constructString()
  }

  ngOnDestroy(): void {
    this.routerSubs.unsubscribe()
    this.queryParamsSubs.unsubscribe()
  }

  reset() {
    this.filter = {
      // search: true
    }
  }



  radiusChange(radius: number) {
    this.searchRadius = radius || 10;
    this.filter = { ...this.filter, radius };
  }

  /** This method checks if the occupants field and check-in checkout date fields are truthy then it update the boolean variable for enabling the search form.*/
  updateSelection(): void {
    const occupants = this.form.get('occupants')?.value;
    if (occupants && this.dateRange) this.isSearchBtnEnabled = true;
  }


  onDateRangeChange(newValue: string) {
    // Handle the updated value of dateRange
    this.handleNoOfDaysCheckedIn(newValue[0], newValue[1])

  }

  /**
   * This method calculates the number of selected days. If the number of selected days is greater than 21, it logs the message "More than 21 days" to the console. Otherwise, it logs Not More than
   */
  handleNoOfDaysCheckedIn(checkinDate: any, checkoutDate: any) {
    const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
    const selectedDays = Math.round(Math.abs((checkoutDate - checkinDate) / oneDay));
    // console.log(selectedDays)
    if (selectedDays > 21) {
      // console.log('More than 21 days');
      const options: any = { class: 'modal-rounded' }
      this.bsModalRef = this.modalService.show(BookingRestrictionModalComponent, options)
      this.bsModalRef.content.onClose.subscribe((res: any) => {
        if (res === true) {
          this.dateRange = []
        }
      })
    }
  }


  search(params?: any) {
    const paginationParams = { page: 1, size: 20, currency: this.selectedCurrency }
    const { rooms, adults, children, pets, infants } = this.form.value
    const queryParams: any = {
      ...this.filter,
      ...paginationParams,
      rooms, adults, children, pets, infants,
      checkIn: this.dateRange ? this.dateRange[0]?.getTime() : 0,
      checkOut: this.dateRange ? this.dateRange[1]?.getTime() : 0,
    }
    if (!queryParams.radius) {
      queryParams.radius = this.searchRadius;
    }
    this.tracker.track(EVENTS.SEARCH_PROPERTY, {});
    if (this.currentUrl.includes('/listings') && (this.currentUrl.includes('page') || this.currentUrl.includes('search'))) {
      this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
    }
    else {
      this.router.navigate(['/listings'], { queryParams, /* queryParamsHandling: 'merge' */ });
    }

    // this.handleNoOfDaysCheckedIn(queryParams.checkIn, queryParams.checkOut)

    this.onsearch.emit()
    // Commented out to prevent calling search endpoint twice, as pagination is callling endpoint as well.
    // this.service.search(queryParams).subscribe((resp: any) => {
    //   this.resources.emit(resp);
    // })
  }

  openFilter(template?: TemplateRef<any>) {
    // this.bsModalRef = this.modalService.show(template, {class: 'modal-rounded modal-content-p0'});
  }

  locationChange(data: any) {
    const latlng = data.latlng.join(',');
    this.latlng = data.latlng.join(',');
    this.filter = { ...this.filter, latlng, s: data.s };

  }

  filters(params: any) {
    this.filter = { ...this.filter, ...params };
  }

  locationInputChange(event: any) {
    if (!event.value) {

    }
  }



  increment(name: string) {
    this.form.controls[name].setValue(+this.form.value[name] + 1)
    this.constructString()

  }

  decrement(name: string) {
    if (+this.form.value[name] > 0) {
      this.form.controls[name].setValue(+this.form.value[name] - 1)
      this.constructString()
    }
  }

  constructString() {

    let string = `${this.form.value['rooms'] ? this.form.value['rooms'] + (this.form.value['rooms'] > 1 ? " Rooms," : " Room,") : ''} ${this.form.value['adults'] ? this.form.value['adults'] + (this.form.value['adults'] > 1 ? " Adults," : " Adult,") : ''} ${this.form.value['children'] ? this.form.value['children'] + (this.form.value['children'] > 1 ? " Children," : " Child,") : ''} ${this.form.value['pets'] ? this.form.value['pets'] + (this.form.value['pets'] > 1 ? " Pets," : " Pet,") : ''} ${this.form.value['infants'] ? this.form.value['infants'] + (this.form.value['infants'] > 1 ? " Infants," : " Infant,") : ''}`
    // this.occupant_types.forEach(occupant => {
    //   string += `${this.form.value[occupant.name] ? this.form.value[occupant.name] + (this.form.value[occupant.name] > 1 ? occupant.name + 's,' :  occupant.name + 's,') : ''}`
    // });
    string = string.trim()
    if (string.charAt(string.length - 1) === ',') {
      let temp = string.split('')
      temp.splice(string.length - 1)
      string = temp.join("")
    }
    this.form.controls['occupants'].setValue(string)
    // this.occupants = string
  }


}
